import React from "react";
import { Navigation } from "../components/Navigation";
import { COPY } from "../constants/copy";

interface MeaningNoteProps {
  onNext: () => void;
  onPrevious: () => void;
}

export const MeaningNote: React.FC<MeaningNoteProps> = ({
  onNext,
  onPrevious,
}) => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-4 bg-warmWhite dark:bg-darkBg transition-colors duration-400 py-20">
      <div className="max-w-2xl text-center space-y-12">
        {/* Decorative element */}
        <div className="text-4xl opacity-40 dark:opacity-30">✦</div>

        {/* Letter-style content */}
        <div className="bg-blushPink dark:bg-darkCard rounded-lg p-8 md:p-12 shadow-md border border-softRose dark:border-gray-700 animate-fade-in">
          <p className="text-lg md:text-xl text-deepCharcoal dark:text-darkText whitespace-pre-line leading-relaxed font-light">
            {COPY.meaningNote.text}
          </p>
        </div>

        {/* Signature-like element */}
        {/* <div className="space-y-2">
          <div className="h-px w-24 bg-heartRed dark:bg-softRose mx-auto"></div>
          <p className="text-sm text-mutedGray dark:text-gray-400 font-light">
            — 60 days later
          </p>
        </div> */}

        <Navigation
          onNext={onNext}
          onPrevious={onPrevious}
          nextLabel={COPY.meaningNote.button}
          showPrevious={true}
        />
      </div>
    </div>
  );
};
